<template>
  <div id="loading-small">
    <template v-if="loading">
      <div class="d-flex flex-justify-center">
        <div data-role="activity" data-type="cycle" data-style="color"></div>
      </div>
      <div class="d-flex flex-justify-center pt-2" v-if="show_text">
        <span>{{ text }}...</span>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      loading: false,
    };
  },
  props:{
    timer: 1000,  show_text: false, text: "Cargando",
  },
  methods: {
    startLoading: function () {
     this.loading = true
    },
    stopLoading: function () {
      setTimeout(()=>{
        this.loading = false;
      },this.timer);
    },
  },

};
</script>

<style>
</style>
